import { render, staticRenderFns } from "./TheTransfer.vue?vue&type=template&id=173e10fa&scoped=true"
import script from "./TheTransfer.vue?vue&type=script&lang=js"
export * from "./TheTransfer.vue?vue&type=script&lang=js"
import style0 from "./TheTransfer.vue?vue&type=style&index=0&id=173e10fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173e10fa",
  null
  
)

export default component.exports